import { Injectable } from '@angular/core';

import { QueryEntity } from '@datorama/akita';

import { LocationsState } from './locations.state';
import { LocationsStore } from './locations.store';

@Injectable({ providedIn: 'root' })
export class LocationsQuery extends QueryEntity<LocationsState> {
  constructor(protected readonly store: LocationsStore) {
    super(store);
  }
}
